/**
 * 新闻文章列表页路径
 */
export const NEWS_LIST_PAGE_PATH = '/news/list'

/**
 * 新闻文章详情页路径
 */
export const NEWS_DETAIL_PAGE_PATH = '/news/detail'
